export const HOURS_PLACEHOLDER = 'hh';
export const MINUTES_PLACEHOLDER = 'mm';
export const DEFAULT_MAX_HOURS = 999;
